// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2dnkW","title":"Header_title__vRhkF","side":"Header_side__1T-6F"};